import Flickity from 'flickity';
import imagesLoaded from 'imagesloaded';

class Carousel {
    constructor(element) {
        this.el = element;
        this.carouselElement = this.el.querySelector('.flickity-carousel');
        this.carouselElementClassList = this.carouselElement.classList;

        // Settings
        this.autoPlayTime = this.carouselElementClassList.contains('_autoplay') ? 5000 : false;
        this.dots = this.carouselElementClassList.contains('_dots');
        this.lazyLoad = this.carouselElementClassList.contains('_lazyload');
        this.wrapAround = this.carouselElementClassList.contains('_wrap-around');
        this.fade = this.carouselElementClassList.contains('_fade');

        this.prevButton = this.el.querySelector('.carousel-button-prev');
        this.nextButton = this.el.querySelector('.carousel-button-next');

        let hasCarouselInit = false;
        imagesLoaded(this.el, { background: false })
            .on('progress', (instance, image) => {
                if (!hasCarouselInit && image.isLoaded) {
                    hasCarouselInit = true;
                    this.initCarousel();
                }
            })
            .on('always', (instance, image) => {
                if (!hasCarouselInit) {
                    // Load carousel if no image has loaded, this is due to failed image loading
                    this.initCarousel();
                }
            });
    }

    initCarousel() {
        this.flickity = new Flickity(this.carouselElement, {
            cellAlign: 'left',
            contain: true,
            draggable: true,
            fade: this.fade,
            lazyLoad: false,
            pageDots: this.dots,
            prevNextButtons: false,
            wrapAround: this.wrapAround,
            selectedAttraction: 0.025, // 0.02
            friction: 0.28, // 0.4
        });

        if (this.autoPlayTime) {
            this.startAutoplayTimer();
        }

        this.addNavigationButtons();
        this.addExternalNavigation(this.el, this.flickity);
    }

    addNavigationButtons() {
        if (this.prevButton) {
            this.prevButton.addEventListener('click', () => {
                this.flickity.previous();
            });
        }

        if (this.nextButton) {
            this.nextButton.addEventListener('click', () => {
                this.flickity.next();
            });
        }
    }

    addExternalNavigation(carousel, instance) {
        const navAttr = 'data-carousel-target';

        document.querySelectorAll(`[${navAttr}]`).forEach(button => {
            button.addEventListener('click', (event) => {
                const slideIndex = parseInt(button.getAttribute(navAttr), 10);

                if (!isNaN(slideIndex)) {
                    if (instance) {
                        instance.select(slideIndex);
                        carousel.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            });
        });
    }

    static initAll() {
        document.querySelectorAll('.carousel').forEach(carousel => new Carousel(carousel));
    }
}

export default Carousel;
